module.exports = __webpack_public_path__ + "img/office1.6ee33432.jpg";